import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star-rating",
  "use": "icon-star-rating-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 15\" id=\"icon-star-rating\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m7.48 11.75-4.397 2.318.84-4.91L.366 5.683l4.915-.716L7.48.5l2.198 4.466 4.915.716-3.556 3.477.84 4.909L7.48 11.75Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol